import { render, staticRenderFns } from "./GoodsPresaleCountryDialog.vue?vue&type=template&id=6bea6cf8&scoped=true&"
import script from "./GoodsPresaleCountryDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsPresaleCountryDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPresaleCountryDialog.vue?vue&type=style&index=0&id=6bea6cf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea6cf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bea6cf8')) {
      api.createRecord('6bea6cf8', component.options)
    } else {
      api.reload('6bea6cf8', component.options)
    }
    module.hot.accept("./GoodsPresaleCountryDialog.vue?vue&type=template&id=6bea6cf8&scoped=true&", function () {
      api.rerender('6bea6cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/GoodsPresaleCountryDialog.vue"
export default component.exports